import moment from 'moment'
import { Entity } from '@/modules/common/domain/entity'

export default class CustomerReward extends Entity {
  used?: boolean
  validTo?: moment.Moment | null
}
